import styles from './index.module.css'

import * as React from 'react'

import { Button } from 'components/ds'

import AddToDiscoSuccessIcon from '../add-to-disco-success-icon'

export default function AddToDiscoSuccessModal({
  onClose,
}: {
  onClose: () => unknown
}): React.ReactNode {
  return (
    <div className={styles.addToDiscoSuccessModalCont}>
      <div>
        <AddToDiscoSuccessIcon />
      </div>
      <div className={styles.addToDiscoSuccessModalTitle}>Success!</div>
      <div className={styles.addToDiscoSuccessModalMessage}>
        <div>We’re adding this music to your DISCO.</div>
        <div>
          You’ll get a notification in the app when it’s finished transferring.
        </div>
      </div>
      <div className={styles.addToDiscoSuccessModalCloseCont}>
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  )
}
